import { RootState } from 'stores';
import { ProductManagementContext, ICheckoutState, IProductsState, TProduct } from './type';

export const getProductManagementContext = (state: RootState): ProductManagementContext => ({
    region: state.productManagement.products.region,
    subscriptionStatus: state.productManagement.products.productList[0]?.status,
});

export const getCheckout = (state: RootState): ICheckoutState => state.productManagement.checkout;
export const getProducts = (state: RootState): IProductsState => state.productManagement.products;
export const getFirstElementInProductList = (state: RootState): TProduct =>
    state.productManagement.products.productList[0];
